import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay, Controller } from 'swiper/modules'
import { app } from '../../../../../assets/js/utils/store'

import each from 'lodash/each'

export default class Carousel {
    constructor({ element }) {
        this.element = element

        this.createCarousel()
    }

    createCarousel() {
        const isGalleryCarousel = this.element.getAttribute('data-carousel') === 'gallery'
        const isVideoCarousel = this.element.getAttribute('data-carousel') === 'video'
        const isDetailsCarousel = this.element.getAttribute('data-carousel') === 'house'

        if (isGalleryCarousel && !app.device?.mobile) {
            this.carousel = new Swiper(this.element, {
                modules: [Autoplay, Navigation],
                speed: 500,
                slidesPerView: 'auto',
                centeredSlides: false,
                spaceBetween: 10,
                preventClicks: false,
                preventClicksPropagation: false,
                navigation: {
                    nextEl: this.element.querySelector("[data-next]"),
                    prevEl: this.element.querySelector("[data-prev]"),
                    clickable: true,
                },
                centerInsufficientSlides: true,
                breakpoints: {
                    768: {
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                        centeredSlides: false,
                    },
                },
                autoHeight: false,
            })
        }

        if (isVideoCarousel && !app.device.mobile) {
            this.carousel = new Swiper(this.element, {
                modules: [Autoplay, Navigation],
                speed: 500,
                slidesPerView: "auto",
                centeredSlides: true,
                spaceBetween: 10,
                navigation: {
                    nextEl: this.element.querySelector("[data-next]"),
                    prevEl: this.element.querySelector("[data-prev]"),
                    clickable: true,
                },
                centerInsufficientSlides: true,
                breakpoints: {
                    768: {
                        slidesPerView: "auto",
                        spaceBetween: 20,
                        centeredSlides: true,
                    },
                },
                autoHeight: false,
            })
        }

        if (isDetailsCarousel) {
            let images = this.element.querySelectorAll('img')

            each(images, (entry) => {
                entry.src = app.webp === true ? entry.getAttribute('data-webp') : entry.getAttribute('data-src')
                entry.onload = () => { entry.setAttribute('loaded', '') }

            })

            this.carousel = new Swiper(this.element, {
                modules: [Pagination, Navigation, Controller],
                speed: 500,
                slidesPerView: 1,
                centeredSlides: false,
                spaceBetween: 0,
                rewind: false,
                // initialSlide: 1,
                // If we need pagination
                navigation: {
                    // nextEl: this.element.querySelector("[data-next]"),
                    // prevEl: this.element.querySelector("[data-prev]"),
                    nextEl: this.element.querySelector("[data-next]"),
                    prevEl: this.element.querySelector("[data-prev]"),
                    clickable: true,
                },
                pagination: {
                    type: "bullets",
                    el: app.statusbar.querySelector("[data-pagination]"),
                    clickable: true,
                    dynamicBullets: true,
                },
                // autoplay: {
                //     delay: 3000,
                // },
                autoHeight: true,
                breakpoints: {
                    768: {
                        slidesPerView: 'auto',
                        spaceBetween: 0,
                        centeredSlides: false,
                        // autoHeight: false,
                    },
                },
                on: {
                    init: (carousel) => {
                        if (carousel.activeIndex == 0) {
                            carousel.navigation.nextEl.classList.add('active')
                        } else {
                            carousel.navigation.nextEl.classList.remove('active')
                        }
                    },
                    activeIndexChange: (carousel) => {
                        if (carousel.activeIndex == 0) {
                            carousel.navigation.nextEl.classList.add('active')
                        } else {
                            carousel.navigation.nextEl.classList.remove('active')
                        }
                    }
                }
            })

            // this.controls = new Swiper(this.element, {
            //     modules: [Navigation, Controller],
            //     navigation: {
            //         nextEl: app.statusbar.querySelector("[data-next]"),
            //         prevEl: app.statusbar.querySelector("[data-prev]"),
            //         clickable: true,
            //     },
            // })

            // this.controls.controller.control = this.carousel
        }
    }
}